export default __webpack_public_path__ + "static/media/login-FB.9a2837bb.svg";